export const downloadBlob = (blob: Blob, filename: string) => {
  const link = document.createElement('a')
  const objectUrl = URL.createObjectURL(blob)
  link.download = filename
  link.href = objectUrl
  document.body.appendChild(link)
  link.click()
  URL.revokeObjectURL(objectUrl)
  document.body.removeChild(link)
}
